import _ from 'lodash'
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import { versions } from '@/modules/limits'
import versionsValidationService from '@/services/versions/versions.service'

export default {
  mixins: [validationMixin],

  computed: {
    modelVersions () {
      return _.get(this.$store.getters, 'knowledgebase/versions/modelVersions')
    },

    errors () {
      let error = ''

      if (!this.$v.newLabel.required) {
        error = this.$t('validations.version-validation.label.required')
      }
      if (!this.$v.newLabel.maxLength) {
        error = this.$t('validations.version-validation.label.maxLength', { maxLength: 30 })
      }
      if (!this.$v.newLabel.nameIsAllowed) {
        error = this.$t('validations.version-validation.label.notAllowedName')
      }
      if (!this.$v.newLabel.nameIsUnique) {
        error = this.$t('validations.version-validation.label.unique')
      }

      return error
    }
  },

  validations () {
    return {
      newLabel: {
        required,
        maxLength: maxLength(versions.nameMaxLength),
        nameIsAllowed: versionsValidationService.nameIsAllowed,
        nameIsUnique: (value) => versionsValidationService.nameIsUnique({
          name: value,
          modelVersions: this.modelVersions
        })
      }
    }
  }
}
